/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react';
import {Helmet} from "react-helmet";
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import TimelineMilestone from "./TimelineMilestone";
import TimelineMilestoneSidebar from "./TimelineMilestoneSidebar";
import './TimelineMilestones.scss';

class TimelineMilestones extends Component {

    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        milestones: PropTypes.array.isRequired
    };

    state = {
        currentYear: null,
        currentIndex: 0,
        order: 'ascending',
        isScrolling: false,
        scrollingTo: null,
        lastTimeUpdated: 0,
        inProp: true,
        isMobile: false,
        intervalId: 0,
        // setIntervalId: 0,
        isPlaying: false,
    };

    componentDidMount() {

        const sorted = this.sortMilestones();

        // Add class on <html>
        if (!document.querySelector('html').classList.contains('timeline_milestone_html')) {
            document.querySelector('html').classList.add('timeline_milestone_html');
        }

        const match = window.matchMedia('(max-width: 768px)');

        const mobileView = () => {
            if (this.state.isMobile !== match.matches) {
                this.setState({isMobile: match.matches});
                this.stopAutoPlay();
            }
            
        }

        mobileView();

        window.addEventListener('resize', mobileView);

        if (!this.state.isMobile && !match.matches) {
            this.stopAutoPlay();
            this.startAutoPlay();
        }

        window.addEventListener('keydown', ({key}) => {
            if(new Date().getTime() - this.state.lastTimeUpdated > 4000) {
                if (['ArrowDown', 'ArrowRight'].includes(key)) {
                    this.goToNextPanel(sorted.length);
                }
                else if (['ArrowUp', 'ArrowLeft'].includes(key)) {
                    this.goToPreviousPanel();
                }
            }
        });

        window.addEventListener('wheel', (e) => {
            // Only allows scroll navigation to happen every 3000ms to
            // avoid scrolling through slides too fast
            if(new Date().getTime() - this.state.lastTimeUpdated > 3000) {
                if(e.deltaY > 50) {
                    this.goToNextPanel(sorted.length);
                } else if(e.deltaY < -50) {
                    this.goToPreviousPanel();
                }
            }
        });

    }

    componentWillUnmount() {
        document.querySelector('html').classList.remove('timeline_milestone_html');
        this.stopAutoPlay();
    }


    /**
     * Set Currently Viewed Year while scrolling on Mobile
     *
     * @param year
     */
    setCurrentYearMobile = year => {
        const yearIndexed = this.sortMilestones().findIndex(milestone => milestone.year === year);
        this.setState({currentIndex: yearIndexed, currentYear: year});
    };

    /**
     * Scroll to Panel by Year using child ref and year matching
     *
     * @param year
     */
    goToYear = year => {
        if (!year) {
            this.setState({currentIndex: 0, currentYear: null});
            return;
        }
        const yearIndexed = this.sortMilestones().findIndex(milestone => milestone.year === year);
        this.setState({currentIndex: yearIndexed, currentYear: year});

        // Track Scrolling for Mobile
        if (this.state.isMobile) {
            this.setState({isScrolling: true, scrollingTo: yearIndexed});
        }

        if (this.state.isPlaying && !this.state.isMobile) {
            this.stopAutoPlay();
            this.startAutoPlay();
        }
    };

    goToPreviousPanel = () => {
        if (this.state.currentIndex > 0) {
            const yearIndexed = this.sortMilestones()[this.state.currentIndex - 1].year;
            this.setState({currentIndex: this.state.currentIndex - 1, currentYear: yearIndexed, lastTimeUpdated: new Date().getTime()});
            if (this.state.isPlaying && !this.state.isMobile) {
                this.stopAutoPlay();
                this.startAutoPlay();
            }
        }
    };

    goToNextPanel = (total) => {
        if (this.state.currentIndex < total - 1) {
            const yearIndexed = this.sortMilestones()[this.state.currentIndex + 1].year;
            this.setState({currentIndex: this.state.currentIndex + 1, currentYear: yearIndexed, lastTimeUpdated: new Date().getTime()});
            if (this.state.isPlaying && !this.state.isMobile) {
                this.stopAutoPlay();
                this.startAutoPlay();
            }
        }
    };

    goToIntroPanel = () => {
        this.setState({currentIndex: 0, currentYear: null});
        if (this.state.isPlaying && !this.state.isMobile) {
            this.stopAutoPlay();
            this.startAutoPlay();
        }
    };

    /**
     * Unset Scrolling State when complete
     */
    goToYearComplete = () => {
        this.setState({isScrolling: false, scrollingTo: null});

        if (this.state.isPlaying && !this.state.isMobile) {
            this.stopAutoPlay();
            this.startAutoPlay();
        }
    };

    /**
     * Sort method for Timeline items by year, placing Intro panels (no year) at the top.
     *
     * @param a
     * @param b
     * @return {*}
     */
    sortOrder = (a, b) => {
        if (!a.year) {
            return false;
        }
        if (!b.year) {
            return true;
        }
        if (a.year === b.year && a.title && b.title) {
            const alphaA = a.title.replace(a.year, '');
            const alphaB = b.title.replace(b.year, '');
            return alphaA > alphaB ? 1 : -1;
        }
        if (this.state.order === 'ascending') {
            return a.year - b.year;
        } else if (this.state.order === 'descending') {
            return b.year - a.year;
        }
        return true;
    };

    sortMilestones = () => {
		const sorted = this.props.milestones.sort(this.sortOrder);
		if (sorted[0].year != null) {
			const intro = sorted.pop();
    		sorted.unshift(intro);
		}
    	return sorted;

    };

    generalPanelsNav = () => {
        // const {goToIntroPanel, goToNextPanel} = this.props;

        // General panels nav

        const sorted = this.sortMilestones();

        const panelSecondaryNav = <div className="panelSecondaryNav">
            <a href="/" className="panelLogo" title="Back to home">
                <img src="/public/images/timelineMilestones/panels/tl__logo.svg" alt="Market Axess logo"/>
            </a>
            <button className="panelBackToTop" onClick={this.goToIntroPanel}>
                <img src="/public/images/timelineMilestones/panels/tl__btt.svg" alt="Arrow to go back to top"/>
                <span>Scroll to Top</span>
            </button>
        </div>;

        const panelPrevButton = <button className="panelPrevButton" onClick={() => this.goToPreviousPanel(sorted.length)}>
            <svg className="panelPrevButton__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451.5 451.5"><title>Up arrow icon</title><polyline fill="none" stroke="#FFFFFF" strokeWidth="1" strokeMiterlimit="10" points="236.8,428.5 225.8,415.6 214.8,428.5"/></svg>
        </button>;

        const panelNextButton = <button className={`panelNextButton ${this.state.currentIndex === this.props.milestones.length - 1 ? 'panelNextButton--last' : ''}`} onClick={() => this.goToNextPanel(sorted.length)}>
            <svg className="panelNextButton__circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451.5 451.5"><circle fill="none" stroke="#FFFFFF" strokeMiterlimit="10" strokeDasharray="12.25,6.15" cx="225.8" cy="225.8" r="225"/></svg>
            <svg className="panelNextButton__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451.5 451.5"><polyline fill="none" stroke="#FFFFFF" strokeWidth="1" strokeMiterlimit="10" points="214.8,23.1 225.7,36 236.8,23.1"/></svg>
        </button>;

        return {
            panelSecondaryNav,
            panelPrevButton,
            panelNextButton
        };
    };

    // handle auto play
    startAutoPlay = () => {
        const sorted = this.sortMilestones();
        this.setState({
            intervalID: setInterval(() => {
                this.goToNextPanel(sorted.length);
            }, 5000)
        });
        this.setState({ isPlaying: true });
    }

    stopAutoPlay = () => {
        clearInterval(this.state.intervalID);
        this.setState({ intervalID: 0 });
        this.setState({ isPlaying: false });
    }

    updateAutoPlay = () => {

        if (this.state.intervalID > 0) {
            this.stopAutoPlay();
        } else {
            this.startAutoPlay();
        }

    };

    render() {

        const sorted = this.sortMilestones();

        const panels = this.generalPanelsNav();

        return (
            <div className={`timelineMilestones timelineMilestones--${this.state.currentYear || 'intro'}`}>
                <Helmet>
                    <title>Milestones | MarketAxess</title>
                </Helmet>

                <TimelineMilestoneSidebar milestones={sorted}
                                          goToYear={this.goToYear}
                                          currentYear={this.state.currentYear}
                />



                {!this.state.isMobile ? (
                    <div className="timelineMilestones__milestones">
                        <TransitionGroup>
                            {sorted.map((milestone, index) => (
                                <TimelineMilestone key={`timelineMilestone__${milestone.year || 'intro'}--${milestone.title}`}
                                                   goToNextPanel={() => this.goToNextPanel(sorted.length)}
                                                   goToIntroPanel={this.goToIntroPanel}
                                                   parentState={this.state}
                                                   index={index}
                                                   isMobile={this.state.isMobile}
                                                   setCurrentYearMobile={() => this.setCurrentYearMobile(milestone.year)}
                                                   isScrolling={this.state.isScrolling}
                                                   goToYearComplete={this.goToYearComplete}
                                                   scrollingTo={this.state.scrollingTo}
                                                   {...milestone}/>
                            ))}

                        </TransitionGroup>
                    </div>
                ) : (
                    <div className="timelineMilestones__milestones timelineMilestones__milestones--mobile">
                        {sorted.map((milestone, index) => (
                            <TimelineMilestone key={`timelineMilestone__${milestone.year || 'intro'}--${milestone.title}`}
                                               goToNextPanel={() => this.goToNextPanel(sorted.length)}
                                               goToIntroPanel={this.goToIntroPanel}
                                               parentState={this.state}
                                               index={index}
                                               isMobile={this.state.isMobile}
                                               setCurrentYearMobile={() => this.setCurrentYearMobile(milestone.year)}
                                               isScrolling={this.state.isScrolling}
                                               goToYearComplete={this.goToYearComplete}
                                               scrollingTo={this.state.scrollingTo}
                                               startAutoPlay={this.startAutoPlay}
                                               stopAutoPlay={this.stopAutoPlay}
                                               isPlaying={this.state.isPlaying}
                                               {...milestone}/>
                        ))}
                    </div>
                )}

                {panels.panelSecondaryNav}

                {panels.panelPrevButton}

                {panels.panelNextButton}

                <button onClick={this.updateAutoPlay} className="timelineMilestone__autoPlay">
                    {
                        (this.state.isPlaying) 
                            ? <span>
                                <span className="fal fa-pause-circle" aria-hidden="true" />
                                <span className="screen-reader-text">Pause the timeline</span>
                            </span>
                            : <span>
                                <span className="fal fa-play-circle" aria-hidden="true" />
                                <span className="screen-reader-text">Play the timeline</span>
                            </span>
                    }
                </button>

            </div>
        );
    }

}

export default TimelineMilestones;



// WEBPACK FOOTER //
// ./frontend/components/TimelineMilestone/TimelineMilestones.jsx